module.exports = __webpack_public_path__ + "img/chain12.f1aca2a8.png";